import React, { useState } from 'react';
import axios from 'axios';
import ProjectsPage from './ProjectsPage';
import MessagesPage from './MessagesPage';
import SkillsPage from './SkillsPage';
import ExperiencePage from './ExperiencePage';
import EducationPage from './EducationPage';
import SystemExperiencePage from './SystemExperiencePage';
import ContactPage from './ContactPage';
import SummaryPage from './SummaryPage';
import CertificatePage from './CertificatePage';

const Dashboard = ({ user, onLogout }) => {
  const [activePage, setActivePage] = useState('projects');

  const renderContent = () => {
    switch (activePage) {
      case 'projects':
        return <ProjectsPage />;
      case 'summary':
        return <SummaryPage />;
      case 'messages':
        return <MessagesPage />;
      case 'skills':
        return <SkillsPage />;
      case 'experience':
        return <ExperiencePage />;
      case 'education':
        return <EducationPage />;
      case 'certifications':
        return <CertificatePage />;
      case 'systems':
        return <SystemExperiencePage />;
      case 'contact':
        return <ContactPage />;
      default:
        return <ProjectsPage />;
    }
  };

  const handleLogout = async () => {
    try {
      // await axios.post('http://localhost:4000/api/auth/logout', {});
      await axios.post('https://nayoolwin-backend-api.vercel.app/api/auth/logout', {});
    } catch (err) {
      console.log('Logout API error:', err);
    } finally {
      localStorage.removeItem('authToken');
      onLogout();
    }
  };

  return (
    <div className="dashboard">
      <aside className="sidebar">
        <h2>Admin Panel</h2>
        <ul className="nav-links">
          <li>
            <button
              className={activePage === 'projects' ? 'active' : ''}
              onClick={() => setActivePage('projects')}
            >
              📁 Projects
            </button>
          </li>
          <li>
            <button
              className={activePage === 'skills' ? 'active' : ''}
              onClick={() => setActivePage('skills')}
            >
              ⚡ Skills
            </button>
          </li>
          <li>
            <button
              className={activePage === 'experience' ? 'active' : ''}
              onClick={() => setActivePage('experience')}
            >
              💼 Experience
            </button>
          </li>
          <li>
            <button
              className={activePage === 'education' ? 'active' : ''}
              onClick={() => setActivePage('education')}
            >
              🎓 Education
            </button>
          </li>
          <li>
            <button
              className={activePage === 'certifications' ? 'active' : ''}
              onClick={() => setActivePage('certifications')}
            >
              🎓 Certifications
            </button>
          </li>
          <li>
            <button
              className={activePage === 'systems' ? 'active' : ''}
              onClick={() => setActivePage('systems')}
            >
              🖥️ Systems
            </button>
          </li>
          <li>
            <button
              className={activePage === 'contact' ? 'active' : ''}
              onClick={() => setActivePage('contact')}
            >
              📞 Contact
            </button>
          </li>
          <li>
            <button
              className={activePage === 'messages' ? 'active' : ''}
              onClick={() => setActivePage('messages')}
            >
              💬 Messages
            </button>
          </li>
          <li>
            <button
                className={activePage === 'summary' ? 'active' : ''}
              onClick={() => setActivePage('summary')}
            >
              🧾 Summary
              </button>
          </li>
        </ul>

        <div style={{ position: 'absolute', bottom: '80px', left: '20px', right: '20px', fontSize: '12px', color: '#bbb' }}>
          <div>User: <strong>{user.username}</strong></div>
          <div style={{ marginTop: '5px' }}>Logged in</div>
        </div>

        <button className="logout-btn" onClick={handleLogout}>
          🚪 Logout
        </button>
      </aside>

      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard;
